import { App, Plugin } from 'vue';

import notify from '@/notify';

const NotifyPlugin: Plugin = {
  install: (app: App) => {
    // For $notify to be typed properly when used as this.$notify, it needs to be typed in ComponentCustomProperties
    // More details in `src/types/vuex-shim.d.ts` file
    app.config.globalProperties.$notify = notify;
    app.provide('notify', notify);
  },
};

export default NotifyPlugin;
